import Content from '../components/Content';
import CreateAutomation from '../components/automation/CreateAutomation';
import AutomationStore from '../stores/AutomationStore';
import AutomationList from '../components/automation/AutomationList';

const Automations = ({userStore}) => {
  const myAutomationStore = new AutomationStore(userStore);

  return (
    <Content title="Interações com usuários fictícios" userStore={userStore}>
      <AutomationList userStore={userStore} />
    </Content>
  )
}

export default Automations
